import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatNativeDateModule, MatRippleModule } from "@angular/material/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldModule,
} from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";
import { TranslatePipe } from "./pipes/translate.pipe";
import { DialogsService } from "./services/dialogs/dialogs.service";
import { SnackService } from "./services/snack-service.service";
import { MatTreeModule } from "@angular/material/tree";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { StickyStackDirective } from "./directives/sticky-stack.directive";
import { TimeAgoPipe } from "./pipes/time-ago.pipe";

@NgModule({
  declarations: [],
  imports: [
    // TimeAgoPipe est désormais standalone — re-exporté ici pour compat.
    TimeAgoPipe,
    TranslatePipe,
    MatTreeModule,
    MatRippleModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatFormFieldModule,
    MatToolbarModule,
    MatIconModule,
    MatInputModule,
    MatCardModule,
    MatExpansionModule,
    MatSnackBarModule,
    MatDialogModule,
    MatListModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    RouterModule,
    MatSelectModule,
    MatSortModule,
    MatAutocompleteModule,
    MatTooltipModule,
    StickyStackDirective,
  ],

  exports: [
    MatRippleModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatToolbarModule,
    MatIconModule,
    MatInputModule,
    MatCardModule,
    MatExpansionModule,
    MatSnackBarModule,
    MatDialogModule,
    MatListModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    RouterModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    NgxSkeletonLoaderModule,
    TranslatePipe,
    TimeAgoPipe,
  ],
  providers: [
    DialogsService,
    SnackService,
    MatNativeDateModule,
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: "outline" },
    },
  ],
})
export class SharedModule {}
